"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.readAction = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source))).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var debug = require("debug")("ReduxList:ReadAction");
/**
 * Call list.read method to set slice.items array
 *
 * @param {Function} dispatch    Redux dispatch
 * @param {Function} api         API method
 * @param {Function} onChange    Appy on items array before changing state
 *
 * @param {Object}  query           Control/Filter attributes
 * @param {Boolean} opt.shouldClear If true, method result will replace existing
 *                                  items. Otherwise, merge both arrays by id
 * @param {Object}  opt.rest        Other options passed when calling list
 *                                  instance .read
 *
 * @return {Promise<Object<error, result>>}
 */


var readAction = function readAction(_ref) {
  var listName = _ref.listName,
      dispatch = _ref.dispatch,
      api = _ref.api,
      hasDispatchStart = _ref.hasDispatchStart,
      hasDispatchEnd = _ref.hasDispatchEnd,
      onChange = _ref.onChange;
  return function () {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$shouldClear = _ref2.shouldClear,
        shouldClear = _ref2$shouldClear === void 0 ? true : _ref2$shouldClear,
        rest = (0, _objectWithoutProperties2.default)(_ref2, ["shouldClear"]);

    if (hasDispatchStart) {
      dispatch({
        type: "".concat(listName, "_READ_START")
      });
    }

    return _promise.default.resolve().then(function () {
      return api(query, _objectSpread({
        shouldClear: shouldClear
      }, rest));
    }).then(function (result) {
      if (hasDispatchEnd) {
        dispatch({
          type: "".concat(listName, "_READ_END"),
          payload: {
            items: (0, _isArray.default)(result) ? result : [result],
            shouldClear: shouldClear,
            onChange: onChange
          }
        });
      }

      return {
        result: result
      };
    }).catch(function (error) {
      // reducer and promise resolve the same data
      error.date = new Date();
      dispatch({
        type: "".concat(listName, "_READ_ERROR"),
        payload: error
      });
      return {
        error: error
      };
    });
  };
};

exports.readAction = readAction;